<template>
  <div
    class="lora-shell app-shell"
    :style="{
      marginTop: headerHeight + 'px',
      minHeight: 'calc(100vh - ' + headerHeight + 'px)'
    }"
  >
    <div class="lora-sidebar app-sidebar" :style="{ top: headerHeight + 'px' }">
      <el-menu
        class="lora-menu"
        :default-active="activeIndex"
        :default-openeds="['device-pool']"
        background-color="transparent"
        @select="selectSection"
      >
        <el-menu-item-group title="Main">
          <el-menu-item index="dashboard">
            <i class="el-icon-s-home"></i>
            <span slot="title">Dashboard</span>
          </el-menu-item>
          <el-menu-item index="sites">
            <i class="el-icon-office-building"></i>
            <span slot="title">Sites</span>
          </el-menu-item>
          <el-submenu index="device-pool">
            <template slot="title">
              <i class="el-icon-cpu"></i>
              <span>Device Pool</span>
            </template>
            <el-menu-item index="gateways">Gateway Pool</el-menu-item>
            <el-menu-item index="end-devices">End Device Pool</el-menu-item>
            <el-menu-item index="smartz-pods">Smartz Pod Pool</el-menu-item>
            <el-menu-item index="minew-nodes">Minew Node Pool</el-menu-item>
            <el-menu-item index="dashboard-displays"
              >Dashboard Display Pool</el-menu-item
            >
          </el-submenu>
          <el-menu-item index="jobs">
            <i class="el-icon-tickets"></i>
            <span slot="title">Jobs</span>
          </el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="Qualification">
          <el-menu-item index="pq">
            <i class="el-icon-finished"></i>
            <span slot="title">PQ Sign-off</span>
          </el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="Config">
          <el-menu-item index="installers">
            <i class="el-icon-user"></i>
            <span slot="title">Installers</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-menu>
    </div>

    <div class="lora-main app-main">
      <div class="lora-content">
        <AppBreadcrumb
          v-if="!detailView"
          root="Installation Tool"
          :current="sectionTitle"
          @root-click="selectSection('dashboard')"
        >
          <el-button
            v-if="pageAction"
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="pageAction.onClick"
            >{{ pageAction.label }}</el-button
          >
        </AppBreadcrumb>

        <div v-if="detailView" class="lora-breadcrumb">
          <span class="lora-breadcrumb__link" @click="goBack">
            <i class="el-icon-arrow-left"></i> Jobs
          </span>
          <span class="lora-breadcrumb__sep">/</span>
          <span class="lora-breadcrumb__current">{{ detailTitle }}</span>
        </div>

        <LoraDashboard
          v-if="section === 'dashboard' && !detailView"
          @open-job="openJobDetail"
          @go-jobs="selectSection('jobs')"
        />
        <LoraSites v-if="section === 'sites' && !detailView" />
        <LoraGatewayPool v-if="section === 'gateways' && !detailView" />
        <LoraEndDevicePool v-if="section === 'end-devices' && !detailView" />
        <LoraSmartzPodPool v-if="section === 'smartz-pods' && !detailView" />
        <LoraMinewNodePool v-if="section === 'minew-nodes' && !detailView" />
        <LoraDashboardDisplayPool
          v-if="section === 'dashboard-displays' && !detailView"
        />
        <LoraJobs
          v-if="section === 'jobs' && !detailView"
          @open-job="openJobDetail"
        />
        <LoraJobDetail
          v-if="detailView === 'job'"
          :job-id="selectedId"
          @back="goBack"
        />
        <LoraPqPending v-if="section === 'pq' && !detailView" />
        <LoraInstallers v-if="section === 'installers' && !detailView" />
      </div>
    </div>
  </div>
</template>

<script>
import LoraDashboard from '@/views/lora/Dashboard'
import LoraSites from '@/views/lora/Sites'
import LoraGatewayPool from '@/views/lora/GatewayPool'
import LoraEndDevicePool from '@/views/lora/EndDevicePool'
import LoraSmartzPodPool from '@/views/lora/SmartzPodPool'
import LoraMinewNodePool from '@/views/lora/MinewNodePool'
import LoraDashboardDisplayPool from '@/views/lora/DashboardDisplayPool'
import LoraJobs from '@/views/lora/Jobs'
import LoraJobDetail from '@/views/lora/JobDetail'
import LoraPqPending from '@/views/lora/PqPending'
import LoraInstallers from '@/views/lora/Installers'
import headerHeight from '@/mixins/headerHeight'
import AppBreadcrumb from '@/components/AppBreadcrumb'

const SECTION_TITLES = {
  dashboard: 'Dashboard',
  sites: 'Sites',
  gateways: 'Gateway Pool',
  'end-devices': 'End Device Pool',
  'smartz-pods': 'Smartz Pod Pool',
  'minew-nodes': 'Minew Node Pool',
  'dashboard-displays': 'Dashboard Display Pool',
  jobs: 'Jobs',
  pq: 'PQ Sign-off',
  installers: 'Installers'
}

export default {
  name: 'Lora',
  components: {
    LoraDashboard,
    LoraSites,
    LoraGatewayPool,
    LoraEndDevicePool,
    LoraSmartzPodPool,
    LoraMinewNodePool,
    LoraDashboardDisplayPool,
    LoraJobs,
    LoraJobDetail,
    LoraPqPending,
    LoraInstallers,
    AppBreadcrumb
  },
  mixins: [headerHeight],
  data() {
    return {
      section: 'dashboard',
      detailView: null,
      selectedId: null,
      detailTitle: '',
      pageAction: null
    }
  },
  computed: {
    sectionTitle() {
      return SECTION_TITLES[this.section] || ''
    },
    activeIndex() {
      return this.detailView === 'job' ? 'jobs' : this.section
    }
  },
  methods: {
    selectSection(s) {
      this.section = s
      this.detailView = null
      this.selectedId = null
      this.pageAction = null
    },
    openJobDetail(job) {
      this.section = 'jobs'
      this.detailView = 'job'
      this.selectedId = job.id
      this.detailTitle = job.name
      this.pageAction = null
    },
    goBack() {
      this.detailView = null
      this.selectedId = null
      this.detailTitle = ''
    },
    setPageAction(action) {
      this.pageAction = action
    },
    clearPageAction() {
      this.pageAction = null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';

// .lora-shell must NOT be position:fixed — a fixed ancestor forms its own stacking
// context, trapping .lora-sidebar's z-index and losing to the global footer bar.
// app-shell is display:flex only, which is safe.

// .app-sidebar sets padding-top:20px; Lora uses group titles for spacing instead.
.lora-sidebar {
  padding-top: 0;
}

.lora-menu {
  padding-bottom: 16px;

  /deep/ .el-menu-item-group__title {
    padding: 16px 16px 4px;
    font-size: 10px;
    font-weight: 600;
    color: var(--sidebar-t2);
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }
}

.lora-content {
  flex: 1;
  padding: 20px 24px;
}

// Only used for the job-detail "Jobs / <job name>" back-link breadcrumb —
// the top-level section breadcrumb now uses the shared AppBreadcrumb
// component instead.
.lora-breadcrumb {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 16px;
  font-size: 13px;

  &__link {
    color: var(--blue);
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  &__sep {
    color: var(--text3);
  }

  &__current {
    font-weight: 600;
    color: var(--text);
  }
}

// Primary button color and table look are now unified globally in
// global.scss (.el-button--primary / .el-table), so no per-module override
// is needed here anymore.
</style>
